module.exports = __webpack_public_path__ + "img/wx_native.864fc197.svg";